<template>
  <div id="app">
    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

export default {
  name: 'charts',
  data () {
    return {
      tableData: [],
      chartOptions: {
        //colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8'],
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          }
        },
        title: {
          text: 'POINT STATUS',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0, // < set this option
            size: '70%',
            dataLabels: {
              distance: 15
            },
            depth: 55
          },
          series: {
              innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<b style="color:#fff ">{point.name}:<br></b><b style="color:#fff "> {point.y}</b>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events:{
              click: this.loadGrid
            },
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        // scroll charts
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [
        {
          name: "SAMPLES",
          colorByPoint: true,         
          data: []
        }
      ],
      drilldown: {
        series: []
      },
      exporting: { enabled: false },
      credits: {
        enabled: false
      },
      loading: {
          labelStyle: {
              color: 'black',
              textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
          },
          style: {
              backgroundColor: 'none',
              opacity: 1,
              marginTop: '20px'
          }
      },

      },//fim chartOptions
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGridOnline']),

    loadGrid(event){
      let status = event.point.drilldown;
      console.log('status', status)

      const ENDPOINT = `v1/get-sensor-status-alarme-grid?planta=${this.filtersOn.planta}&status=${status}&skipped=`

      let gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        columns: {
              "area": ['Area'],
              "setor": ['Sector'],
              "conj": ['Machine', 'conjunto'],
              "conj_tag": ['Machine TAG'],
              "equip": ['Component'],
              "equip_tag": ['Component TAG'],
              "ponto": ['Point'],
              "serie": ['Serie'],
              "versao": ['Firmware version'],
              "data": ['Sample date'],
              "bateria": ['Battery level'],
              "sinal_nivel": ['BLE signal'],
              "status": ['Status'],
              "rdps": ['DR']
        },
        show: true
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name
        delete gridOnline.columns['planta']
      }

      this.changeGridOnline(gridOnline);

    },

    getData(){
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/get-sensor-status-alarme'
      let self = this;

      this.$refs.chart.chart.showLoading();

      axios({method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {     
        self.tableData = resp.data.result;  
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        self.$refs.chart.chart.showLoading('Error');

        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
      })

    },
    setChartData () {
        var self = this
        var res = self.tableData
        var values = []

        for (var key in res) {
          if(res[key].status == 1){
            var color = '#90ed7d'
            var name = 'Normal'
          }
          if(res[key].status == 2){
            var color = '#e4d354'
            var name = 'Alert'
          }
          if(res[key].status == 3){
            var color = '#f45b5b'
            var name = 'Alarm'
          }
          if(res[key].status == 4){
            var color = '#6b91c9'
            var name = 'N/A'
          }
        
          values.push({'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color })
        }
        self.chartOptions.series[0].data = values


    }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style>
/*tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 10px;
}*/
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/ChartsPointStatus.vue